import { render, staticRenderFns } from "./UserTables.vue?vue&type=template&id=4ba6357c&"
import script from "./UserTables.vue?vue&type=script&lang=js&"
export * from "./UserTables.vue?vue&type=script&lang=js&"
import style0 from "./UserTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports